import React, { useEffect, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Button,
    Modal,
    IconButton,
    TextareaAutosize,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import { takrarPranaliData, takrarPranaliUpdate } from "../utils/axios";
import { ATTACHMENT_URL } from "../utils/api";
import TopBar from "./TopBar";

const TakrarPranaliData = () => {
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);
    const [updatedTakrar, setUpdatedTakrar] = useState("");
    const [updatedFile, setUpdatedFile] = useState(null);
    const [error, setError] = useState("");
    const [getId, setGetId] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    // Fetch Data from API
    const fetchData = async () => {
        try {
            const response = await takrarPranaliData();
            setData(response.data?.data || []);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    // Open Edit Modal
    const handleEdit = (row) => {
        setCurrentRow(row);
        setUpdatedTakrar(row.reply);
        setUpdatedFile(null);
        setError("");
        setOpen(true);
        setGetId(row.takrar_id);
    };

    // Handle File Change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setUpdatedFile(file);
    };

    // Handle Save Action
    const handleSave = async () => {
        if (!updatedTakrar.trim()) {
            setError("Takrar field is required.");
            return;
        }

        const formData = new FormData();
        formData.append("reply", updatedTakrar);
        if (updatedFile) {
            formData.append("reply_attachment", updatedFile);
        }

        try {
            await takrarPranaliUpdate(formData, getId);
            setOpen(false);
            fetchData(); // Refresh data after update
        } catch (error) {
            console.error("Error updating data:", error);
        }
    };
    // const offices = [
    //     { id: "21", name: "उपविभागीय कार्यालय छत्रपती संभाजीनगर" },
    //     { id: "22", name: "उपविभागीय कार्यालय पैठण-फुलंब्री" },
    //     { id: "23", name: "उपविभागीय कार्यालय वैजापूर" },
    //     { id: "24", name: "उपविभागीय कार्यालय सिल्लोड" },
    //     { id: "25", name: "उपविभागीय कार्यालय कन्नड" },
    //     { id: "26", name: "तहसील कार्यालय छत्रपती संभाजीनगर ग्रामीण" },
    //     { id: "27", name: "तहसील कार्यालय छत्रपती संभाजीनगर शहरी" },
    //     { id: "28", name: "तहसील कार्यालय पैठण" },
    //     { id: "29", name: "तहसील कार्यालय फुलंब्री" },
    //     { id: "30", name: "तहसील कार्यालय वैजापूर" },
    //     { id: "31", name: "तहसील कार्यालय गंगापूर" },
    //     { id: "32", name: "तहसील कार्यालय खुलताबाद" },
    //     { id: "33", name: "तहसील कार्यालय सिल्लोड" },
    //     { id: "34", name: "तहसील कार्यालय कन्नड" },
    //     { id: "35", name: "तहसील कार्यालय सोयगाव" }
    // ];


    const offices = [
        { id: 0, name: " विभागीय आयुक्त कार्यालय, छत्रपती संभाजीनगर" },
        { id: 36, name: "जिल्हाधिकारी कार्यालय छत्रपती संभाजीनगर" },
        { id: 37, name: "जिल्हाधिकारी कार्यालय जालना" },
        { id: 38, name: "जिल्हाधिकारी कार्यालय बीड" },
        { id: 39, name: "जिल्हाधिकारी कार्यालय लातूर" },
        { id: 40, name: "जिल्हाधिकारी कार्यालय धाराशिव" },
        { id: 41, name: "जिल्हाधिकारी कार्यालय नांदेड" },
        { id: 42, name: "जिल्हाधिकारी कार्यालय परभणी" },
        { id: 43, name: "जिल्हाधिकारी कार्यालय  हिंगोली" },
        { id: 50, name: "सूचना व तक्रार प्रणाली  विभागीय आयुक्त कार्यालय, छत्रपती  संभाजीनगर" }
    ];

    const [talukaId, setTalukaId] = useState(null);

    useEffect(() => { 
        const storedId = localStorage.getItem("t_id");
        if (storedId) {
            setTalukaId(Number(storedId)); // convert to number
        }
    }, []);

    return (
        <Box className="ff_baloo" sx={{ width: "90%", marginLeft: "6.5%", marginTop: "6.5%" }}>
            <TopBar />
            <Paper sx={{ my: 5, overflowX: "auto", boxShadow: "none" }}>
                <Typography
                    variant="h6"
                    align="center"
                    className="ff_yatra"
                    sx={{ fontSize: "35px", padding: "10px" }}
                >
                    तक्रार प्रणाली
                </Typography>
                <Typography
                    variant="h3"
                    align="center"
                    sx={{
                        color: '#000',
                        mb: 2,
                        fontSize: { xs: '22px', sm: '24px', md: '28px', lg: '30px' },
                    }}
                    className="ff_yatra"
                >
                    महसूल विभाग   {
                        (offices.find((office) => office.id === talukaId)?.name) || talukaId
                    }

                </Typography>

                {/* Table */}
                <TableContainer sx={{ border: "1px solid #ccc" }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                {[
                                    "Sr No",
                                    "Reference No",
                                    "Details",
                                    "Takrar",
                                    "Offices",
                                    "Attachment",
                                    "Status",
                                    "Date",
                                    "Reply",
                                    "Action"
                                ].map((header) => (
                                    <TableCell
                                        className="ff_yatra"
                                        key={header}
                                        sx={{
                                            fontSize: "18px",
                                            color: "#333",
                                            textAlign: "center",
                                            padding: "14px",
                                            border: "1px solid #ccc",
                                            background: "#f0f0f0",
                                        }}
                                    >
                                        {header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.length > 0 ? (
                                data.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>
                                            {index + 1}
                                        </TableCell>
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>
                                            {row.reference_no || "-"}
                                        </TableCell>
                                        {/* Combined Column */}
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>
                                            <div>{row.name}</div>
                                            <div>{row.email}</div>
                                            <div>{row.mobile_no}</div>
                                        </TableCell>

                                        {/* Takrar */}
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>
                                            {row.takrar}
                                        </TableCell>
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>
                                            {(offices.find(offices => offices.id == String(row.taluka_id))?.name) || row.taluka_id}
                                        </TableCell>

                                        {/* Attachment */}
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>
                                            {row.attachment_file ? (
                                                <Button
                                                    onClick={() => window.open(`${ATTACHMENT_URL}/${row.attachment_file}`)}
                                                    variant="outlined"
                                                    size="small"
                                                    color="primary"
                                                >
                                                    View Attachment
                                                </Button>
                                            ) : (
                                                "No Attachment"
                                            )}
                                        </TableCell>

                                        {/* Status Column */}
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>
                                            <TableCell
                                                align="center"
                                                className="ff_baloo"
                                                sx={{
                                                    border: 'none',
                                                    fontWeight: "bold",
                                                    color: row.status == 2 ? "red" : "green",
                                                }}
                                            >
                                                {row.status == 2 ? "Close" : "Pending"}
                                            </TableCell>
                                        </TableCell>
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>
                                            {new Date(row.created_at).toLocaleDateString("en-IN", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                            })}
                                            <br />
                                            {new Date(row.created_at).toLocaleTimeString("en-IN", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                second: "2-digit",
                                                hour12: true,
                                            })}
                                        </TableCell>
                                        {/* reply */}
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>
                                            {row.reply}
                                            <br />
                                            {row.reply_attachment ? (
                                                <Button
                                                    onClick={() => window.open(`${ATTACHMENT_URL}/${row.reply_attachment}`)}
                                                    size="small"
                                                    color="primary"
                                                >
                                                    View Attachment
                                                </Button>
                                            ) : (
                                                "No Attachment"
                                            )}
                                        </TableCell>
                                        {/* Action */}
                                        <TableCell align="center" sx={{ border: "1px solid #ccc" }}>
                                            <Button
                                                onClick={() => handleEdit(row)}
                                                disabled={row.status == 2}
                                            >
                                                <EditIcon />
                                            </Button>
                                        </TableCell>

                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={7} align="center" sx={{ border: "1px solid #ccc" }}>
                                        No data available
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            {/* Edit Modal */}
            <Modal open={open} onClose={() => setOpen(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 400,
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 3,
                        borderRadius: "8px",
                    }}
                >
                    <IconButton
                        onClick={() => setOpen(false)}
                        sx={{ position: "absolute", top: 10, right: 10 }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Typography variant="h6" mb={2}>
                        Update Takrar
                    </Typography>

                    {/* Textarea for Takrar */}
                    <TextareaAutosize
                        minRows={4}
                        placeholder="Enter Takrar"
                        value={updatedTakrar}
                        onChange={(e) => setUpdatedTakrar(e.target.value)}
                        style={{
                            width: "100%",
                            padding: "8px",
                            fontSize: "16px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            outline: "none",
                        }}
                    />

                    {/* File Upload */}
                    <input type="file" onChange={handleFileChange} style={{ marginTop: "10px" }} />

                    {error && (
                        <Typography color="error" mt={1}>
                            {error}
                        </Typography>
                    )}

                    {/* Save and Close Buttons */}
                    <Box mt={3} display="flex" justifyContent="space-between">
                        <Button onClick={handleSave} variant="contained" color="primary">
                            तक्रार बंद करा
                        </Button>
                        {/* <Button onClick={() => setOpen(false)} variant="outlined" color="secondary">
                            Close
                        </Button> */}
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};

export default TakrarPranaliData;
